import React from "react";

export default function PaypalIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          fill="#currentColor"
          d="M21.09 5.652c.18-1.607-.14-2.748-1.053-3.79-1.095-1.246-3.07-1.78-5.598-1.78H7.1a1.05 1.05 0 0 0-1.037.885L3.007 20.346a.63.63 0 0 0 .623.729h4.134l-.303 1.92a.942.942 0 0 0 .93 1.088h3.819c.643 0 1.19-.464 1.293-1.096l.037-.195.72-4.565.045-.245.002-.011a.527.527 0 0 1 .522-.445h.57c1.899 0 3.637-.384 5.017-1.366a6.187 6.187 0 0 0 1.49-1.507 7.412 7.412 0 0 0 1.32-3.293c.363-1.868.195-3.533-.855-4.73a4.03 4.03 0 0 0-1.14-.885l-.141-.093Zm-11.276 7.66c.149-.078.314-.118.482-.118h2.154c4.23 0 7.54-1.717 8.508-6.684l.004-.024c.326.186.6.405.822.657.82.934 1.019 2.302.675 4.064-.408 2.096-1.299 3.461-2.494 4.311-1.203.855-2.763 1.223-4.565 1.223h-.57a1.31 1.31 0 0 0-1.294 1.101l-.045.246-.72 4.564-.036.195-.002.006a.528.528 0 0 1-.522.444H8.392a.158.158 0 0 1-.153-.116.16.16 0 0 1-.004-.068l.312-1.98 1.267-7.821Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .082h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
